import { makeAutoObservable } from "mobx"
import PopupsManager from "react-sdk/PopupsManager"
import AppState, { POPUPS } from "./AppState"

class Periods {
    all = {}

    init(periods) {
        periods.forEach(p => {
            if (p.id) {
                if (this.all[p.id] !== undefined) {
                    window.alert("Careful, some period have the same id (" + p.id + "), check your periods.data file")
                }
                this.all[p.id] = {
                    id: p.id,
                    type: p.type,
                    title: p.title,
                    timeframe: p.timeframe,
                    endDesciption: p.endDesciption,
                    pois: p.pois.split(",")
                }
            }
        })
        makeAutoObservable(this)
    }

    get(id) {
        return this.all[id]
    }

    select(id) {
        let prom;

        if (AppState.period) {
            PopupsManager.close(POPUPS.LOADING)

            prom = new Promise((resolve) => {
                PopupsManager.queue(POPUPS.PERIOD, { id: id, end: true }, () => {
                    resolve();
                });
            });
        } else {
            prom = Promise.resolve();
        }

        return prom
            .then(() => {
                PopupsManager.open(POPUPS.LOADING)

                AppState.period = this.all[id];

            })
            .then(() => {
                if (AppState.period.type === "selection") return Promise.resolve()

                return new Promise((resolve) => {

                    setTimeout(() => {

                        AppState.reaxe_api.toHaxe(
                            "map",
                            "HideAllPoisExpects",
                            AppState.period.pois,
                            () => {
                                resolve();
                            }
                        );
                    }, 150)
                });
            })
            .then(() => {
                return new Promise((resolve) => {

                    PopupsManager.close(POPUPS.LOADING)

                    PopupsManager.open(POPUPS.PERIOD, { id: id, end: false }, () => {
                        resolve();
                    });
                });
            });
    }
}

export default new Periods()